import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const GENERATE_ALL_DRAWS_REQUEST = 'GENERATE_ALL_DRAWS_REQUEST';
export const GENERATE_ALL_DRAWS_FAILURE = 'GENERATE_ALL_DRAWS_FAILURE';
export const GENERATE_ALL_DRAWS_SUCCESS = 'GENERATE_ALL_DRAWS_SUCCESS';

/**
 * `approve` also approves every draw THIS call generates — «згенерувати та
 * затвердити одним рухом». Drafts that already existed are left as they are
 * (CompetitionDrawHandler::generateAllDraws()).
 */
export const generateAllDraws = (competitionId, { approve = false } = {}) => {
    return function(dispatch) {
        dispatch({ type: GENERATE_ALL_DRAWS_REQUEST });

        const options = apiRequestOptions(apiPath.COMPETITIONS.GENERATE_ALL_DRAWS, approve ? { approve: true } : null, {
            params: { id: competitionId },
        });

        return axios(options)
            .then(transformHttpResponse)
            .then(response => {
                // `competition` so caches keyed on it can invalidate — this
                // one changes every category's fight count at once.
                dispatch({ type: GENERATE_ALL_DRAWS_SUCCESS, result: response.data, competition: competitionId });
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: GENERATE_ALL_DRAWS_FAILURE, error });
                dispatch(errorRequestHandler(error));
                throw error;
            });
    };
};

/**
 * Where the competition's draws stand, counted by the server:
 * {categories, drawn, notDrawn, approved}. Resolves null when it cannot be
 * read — the counts are a status line, not something to raise an error over.
 */
export const fetchDrawStatus = competitionId => () =>
    axios(apiRequestOptions(apiPath.COMPETITIONS.DRAW_STATUS, null, { params: { id: competitionId } }))
        .then(transformHttpResponse)
        .then(response => response.data || null)
        .catch(() => null);

/**
 * Which protocol every drawn category will run at the mat, round by round
 * (GET …/protocol-readiness) — the Overview tab's «Готовність протоколів».
 * Resolves null when it cannot be read.
 */
export const fetchProtocolReadiness = competitionId => () =>
    axios(apiRequestOptions(apiPath.COMPETITIONS.PROTOCOL_READINESS, null, { params: { id: competitionId } }))
        .then(transformHttpResponse)
        .then(response => response.data || null)
        .catch(() => null);

/**
 * The competition's readiness checklist (GET …/readiness): draws, schedule,
 * mats prepared and staffed, displays, officials. Resolves null when it
 * cannot be read.
 */
export const fetchCompetitionReadiness = competitionId => () =>
    axios(apiRequestOptions(apiPath.COMPETITIONS.READINESS, null, { params: { id: competitionId } }))
        .then(transformHttpResponse)
        .then(response => response.data || null)
        .catch(() => null);

/**
 * WHETHER EVERY CATEGORY'S RESULT IS CONFIRMED (GET …/results-readiness),
 * with the detail of what is not — the Reports tab's indicator.
 *
 * A DIFFERENT question from the checklist above, asked at the other end of
 * the day: that one is «can we start», this one is «can we print the final
 * documents». The ranking reports and the mandate protocol are only true once
 * every category has been confirmed, and until 30 Sep 2026 nothing on that
 * page said whether they were.
 *
 * Resolves null when it cannot be read — an indicator that cannot be drawn is
 * left out rather than shown wrong.
 */
export const fetchResultsReadiness = competitionId => () =>
    axios(apiRequestOptions(apiPath.COMPETITIONS.RESULTS_READINESS, null, { params: { id: competitionId } }))
        .then(transformHttpResponse)
        .then(response => response.data || null)
        .catch(() => null);
